export function useField(field) {
  const value = ref(field.value);
  const valid = ref(true);
  const touched = ref(false);
  const focused = ref(false);
  const errorsCount = ref(0);
  const classError = ref(false);
  const showError = ref(false);
  const errors = reactive({});

  const reassign = (val) => {
    let _errorsCount = 0;
    valid.value = true;
    Object.keys(field.validators ?? {}).map((name) => {
      const isValid = field.validators[name](val);
      errors[name] = !isValid;
      if (!isValid) {
        _errorsCount++;
        valid.value = false;
      }
    });
    errorsCount.value = _errorsCount;
    _showError();
  };

  const _showError = () => {
    classError.value = errorsCount.value && touched.value && !focused.value;
    showError.value = errorsCount.value && touched.value;
  }

  watch(value, reassign);

  reassign(field.value);

  return {
    value,
    valid,
    touched,
    focused,
    showError,classError,
    errors,
    blur: () => {
      value.value = value.value.replace(/<\/?[^>]+(>|$)/g, "").trim().replace(/\s+/g, " ");
      touched.value = true;
      focused.value = false;
      _showError();
    },
    focus: () => {
      focused.value = true;
      _showError();
    },
  };
}
